@if (isBusClassCompute) {
  <div [ngClass]="{'lm-is-radio-in-paragraph': lmParagraphLayoutInfo, 'lm-radio-field-options': true}">
    <input type="radio"
      class="radio"
      soho-radiobutton (change)="handleComputeTypeChange($event)"
      soho-trackdirty
      id="option1ComputeType" attr.name="optionsComputeType" value="compute"
      attr.data-automation-id="{{computeOptionAutomationId}}"
      [(ngModel)]="computeType"/>
      <label soho-label for="option1ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'ComputeEditorColumnComputeLabel' | translate}}</label>
      <input type="radio"
        class="radio"
        soho-radiobutton (change)="handleComputeTypeChange($event)"
        soho-trackdirty
        id="option2ComputeType" attr.name="optionsComputeType" value="derived"
        attr.data-automation-id="{{derivedOptionAutomationId}}"
        [(ngModel)]="computeType"/>
        <label soho-label for="option2ComputeType" [forRadioButton]="true" class="lm-radio-button-label">{{ 'DerivedLabel' | translate}}</label>
      </div>
    }
    @if (label) {
      <label
        [attr.for]="id"
        soho-label
        [required]="required$ | async"
        lm-label
        [layoutField] = "field"
        >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
    }
    <div class="field">
      <div
        lm-field-options
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [disableFieldOptions]="disableFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
        soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
        (focusin)="onFieldFocus($event)"
        (focusout)="onFieldBlur($event)"
        (contextmenu)="onContextMenu($event)">
        @if (!displayAsText) {
          <div class="bcf-editor">
            <div class="editor-container lm-lpl-editor" #editorContainer soho-alert soho-trackdirty [attr.id]="id" [attr.bindId]="bindId"></div>
          </div>
        } @else {
          <p
            [attr.id]="id"
            [ngClass]="fieldClassesString"
            [attr.tabindex]="isInAccessibilityMode ? 0 : -1"
            soho-alert
            lm-field-style
            [specField]="specField"
            [fieldStyle]="layoutObject?.fieldStyle"
            [recalculateStyles]="triggerValueChange | async"
          >{{modelField.valueChanged | async | formatMessageRule:true:field.text:model:specFields}}</p>
        }
      </div>
    </div>
    @if (!displayAsText) {
      @if (isBusClassTotal) {
        <div class="two-button">
          <button
            soho-button="primary"
            [disabled]="disableDimensions$ | async"
            (click)="onBuildCubeRelation()"
            attr.data-automation-id="{{builderButtonAutomationId}}"
            >{{ 'SetDimensions' | translate}}
          </button>
          @if (!hideTestMeasures) {
            <button
              soho-button="secondary"
              (click)="onPreviewCubeRelation()"
              attr.data-automation-id="{{previewButtonAutomationId}}"
              >{{ 'Validate' | translate }}
            </button>
          }
        </div>
      } @else {
        @if (isBusinessMetricCompute) {
            <div class="">
                <button
                  soho-menu-button="secondary"
                  class="btn-secondary"
                  [ajaxBeforeOpenFunction]="metricAddMenuItems"
                  [disabled]="readOnly$ | async"
                  menu="metric-add-menu-popup"
                  (selected)="onMetricMenuItemSelected($event)"
                  attr.data-automation-id="{{AddMetricMenuButtonAutomationId}}"
                >{{ 'Add' | translate}}</button>
                <button
                    soho-button="secondary"
                    [attr.disabled]="viewMetricButtonDisabled || isDisabled ? 'disabled' : null"
                    (click)="onViewMetricEvent($event)"
                    attr.disabled="metricNotSelected"
                    attr.data-automation-id="{{addMetricButtonAutomationId}}"
                >{{ 'ViewMetric' | translate}}</button>
<!--
                <button
                    soho-button="secondary"
                    [disabled]="readOnly$ | async"
                    (click)="onAddMetricEvent()"
                    attr.data-automation-id="{{addMetricButtonAutomationId}}"
                >{{ 'AddMetric' | translate}}</button>
                <button
                    soho-button="secondary"
                    [disabled]="readOnly$ | async"
                    (click)="onAddToMetricCompute('ADD_RATIO')"
                    attr.data-automation-id="{{addRatioButtonAutomationId}}"
                >{{ 'AddRatio' | translate}}</button>
                <button
                    soho-button="secondary"
                    [disabled]="readOnly$ | async"
                    (click)="onAddToMetricCompute('ADD_VARIANCE_AMOUNT')"
                    attr.data-automation-id="{{addVarianceAmountButtonAutomationId}}"
                >{{ 'AddVarianceAmount' | translate}}</button>
                <button
                    soho-button="secondary"
                    [disabled]="readOnly$ | async"
                    (click)="onAddToMetricCompute('ADD_VARIANCE_PERCENT')"
                    attr.data-automation-id="{{addVariancePercentButtonAutomationId}}"
                >{{ 'AddVariancePercent' | translate}}</button>
                <button
                    soho-menu-button="secondary"
                    class="btn-secondary"
                    [ajaxBeforeOpenFunction]="metricAddMenuItems"
                    [disabled]="readOnly$ | async"
                    menu="metric-add-menu-popup"
                    (selected)="onMetricMenuItemSelected($event)"
                    attr.data-automation-id="{{AddMetricMenuButtonAutomationId}}"
                >{{ 'MetricAddMenu' | translate}}</button>
-->
                <ul soho-popupmenu id="metric-add-menu-popup">
                </ul>
            </div>
        }
        @else if (!isBusClassCompute && !isBusinessMetricCompute) {
          <div class="two-button">
            <button
              soho-button="primary"
              [disabled]="readOnly$ | async"
              (click)="onBuildButtonEvent()"
              attr.data-automation-id="{{builderButtonAutomationId}}"
            >{{ 'BuilderNoEllipses' | translate}}</button>
            @if (layoutObject.lplFieldInfo?.mode !== 'DerivedField') {
              <button
                soho-button="secondary"
                [disabled]="readOnly$ | async"
                (click)="onPreviewButtonEvent()"
                attr.data-automation-id="{{previewButtonAutomationId}}"
              >{{ 'PreviewNoEllipses' | translate }}</button>
            }
          </div>
        } @else if (!isBusinessMetricCompute) {
          <div class="one-button">
            <button
              soho-button="primary"
              [disabled]="readOnly$ | async"
              (click)="onComputeBuildButtonEvent()"
              attr.data-automation-id="{{builderButtonAutomationId}}"
            >{{ 'BuilderNoEllipses' | translate}}</button>
          </div>
        }
      }
    }
    <ng-template #mouseOverTextTemplate>
      @if (layoutObject.mouseOverText) {
        <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
      }
    </ng-template>

  <span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
